import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { toUrl } from 'util/link';
import Head from 'next/head';

export function AmpInstagramEmbed({ url }) {
  const parsed = toUrl(url);
  // Get last path segment
  const shortCode = parsed.pathname.match(/([^/]+)\/?$/)[1];

  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-instagram"
          key="amp-instagram-embed"
          src="https://cdn.ampproject.org/v0/amp-instagram-0.1.js"
        />
      </Head>
      <amp-instagram
        data-shortcode={shortCode}
        width="600"
        height="450"
        layout="responsive"
      />
    </Fragment>
  );
}

AmpInstagramEmbed.propTypes = {
  url: string
};

AmpInstagramEmbed.defaultProps = {
  url: undefined
};

export default AmpInstagramEmbed;
